addEventListener('turbo:before-cache', () => {
	document
		.querySelectorAll('turbo-frame[loading="lazy"][complete]')
		.forEach(frame => frame.removeAttribute('loading'))
})
